/**
 * Formats a raw Instagram username as an owner-friendly handle (`@username`).
 *
 * Every surface that shows a contact's Instagram identity must render this
 * — never the raw platform IGSID (`ig_user_id`/`instagram_user_id`), which
 * is technical data with no meaning to the tenant owner.
 */
export function igHandle(username: string | null | undefined): string | null {
  if (!username) return null;
  return `@${username}`;
}
